export default "__VITE_ASSET__2wQ3T8mT__"